<template>
    <div v-b-visible="mountedAction">
        <span v-if="data == null" style="min-height: 200px; padding-top:80px;">
            <loading-spinner :busy="data == null" heavy-data-load></loading-spinner>
        </span>
        <span v-else>
            <div class="text-center">Total Order Count</div>
            <Conversion2Bar :data="chartData2" :options="chartData.options" style="height: 200px"></Conversion2Bar>
            <hr>
            <div class="text-center">Conversion 2 Rate</div>
            <Conversion2Line :data="chartData" :options="chartData.options" style="height: 300px"></Conversion2Line>
        </span>
    </div>
</template>

<script>
    import _ from 'lodash';
    import Conversion2Line from '../graphs/Conversion2Line.vue';
    import Conversion2Bar from '../graphs/Conversion2Bar.vue';
    import LoadingSpinner from "../../../components/LoadingSpinner";
    export default {
        components: {LoadingSpinner, Conversion2Line, Conversion2Bar},
        name: 'TestCard',
        props: {
            dataDisplay: {type:String,default: null},
            main_icon: {type:String,default:''},
            name: String,
            load_url: String,
            icons: Array,
            time_wait: { type: Number, default: 10000000 },
            title: String,
            bgColor: {type: String, default: 'light'},
        },
        data(){
            return {
                chartData2: {
                    datasets: [
                        {
                            data: [],
                            backgroundColor: '#20a8d869',
                            borderColor: "#20a8d8",
                            borderWidth: 2,
                        }
                    ],
                    labels: [],
                    options: null,
                },
                chartData: {
                    datasets: [
                        {
                            data: [],
                            label: '7 Day',
                            borderColor: "#ECBC55",
                            fill: false,
                            lineTension: 0,
                        },
                        {
                            data: [],
                            label: '14 Day',
                            borderColor: "#4ECCA3",
                            fill: false,
                            lineTension: 0,
                        },
                        {
                            data: [],
                            label: '21 Day',
                            borderColor: "#E16428",
                            fill: false,
                            lineTension: 0,
                        },
                        {
                            data: [],
                            label: '30 Day',
                            borderColor: "#6198a9",
                            fill: false,
                            lineTension: 0,
                        },
                        {
                            data: [],
                            label: 'Overall',
                            borderColor: "#1D3E53",
                            fill: false,
                            lineTension: 0,
                        },
                    ],
                    labels: [],
                    options: null,
                },
                hasAction: false,
                data: null,
            };
        },
        beforeDestroy(){
            clearInterval(this.interaval);
        },
        methods:{
            callAPI: function () {
                var _this = this;
                this.$http.post(this.load_url)
                        .then(response => {
                    _this.data = response.data.data;
                    _this.data = _.sortBy( _this.data, 'week_date');

                    _this.createChartData();
                });
            },


            mountedAction(viewable) {
                if(!this.hasAction && viewable) {
                    this.callAPI();
                    this.interaval = setInterval(
                            this.callAPI,
                            this.time_wait
                    );
                    this.hasAction = true;
                }
            },
            createChartData() {
                let that = this;
                that.chartData.labels = [];
                this.data.forEach( function (d, i) {

                    // total orders
                    that.chartData2.labels.push(d.week_date);
                    that.chartData2.datasets[0].data.push( that.data[i].C1 );

                    // conversion2 % by day
                    that.chartData.labels.push(d.week_date);
                    that.chartData.datasets[0].data.push( ((that.data[i].C2_7/that.data[i].C1 ) * 100).toFixed(2) );
                    that.chartData.datasets[1].data.push( ((that.data[i].C2_14/that.data[i].C1 ) * 100).toFixed(2) );
                    that.chartData.datasets[2].data.push( ((that.data[i].C2_21/that.data[i].C1 ) * 100).toFixed(2) );
                    that.chartData.datasets[3].data.push( ((that.data[i].C2_30/that.data[i].C1 ) * 100).toFixed(2) );
                    that.chartData.datasets[4].data.push( ((that.data[i].C2_total/that.data[i].C1 ) * 100).toFixed(2) );


                });
            },
        },
    };

</script>


<style scoped>
    .merge-card {
        flex: 1;
        margin:0 1.5%;
    }

    .data {
        flex: 1;
        border-bottom: 1px solid #f4f4f4
    }
    .data__title {
        font-weight: 400;
    }
    .data__num {
        float: right;
    }

</style>